import React, { useEffect, useState } from "react";
import { SelectInputWTitle } from "./SelectInputWTitle";
import { Loading } from "../Loading";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { LoadingColor } from "../LoadingColor";
import { TextBtn2 } from "./TextBtn2";
import { IconAddBulk } from "../../Assets/panels/IconAddBulk";
import PopupMainPanel from "../Forms/PopupMainPanel";
import FormTags from "../Forms/FormTags";
import { DictioneryPanel } from "../../Data/DictioneryPanel";


export const TagsV2Selector = ({
    style,
    name,
    title,
    error = "",
    first,
    value,
    onchange,
    placeHolder,
    selectableFirst,
    required,
    ltr,
    lan= false,
    disabled=false,
    search= false,
    lang = "fa",
    add = true,
}) => {
    const [loading, setLoading] = useState(false);
    const [data, setDeta] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogData, setDialogData] = useState(false);
    const apiBase = `${apiMain}/api/v2/setting/V2_tags`;
    // check subsystem
    useEffect(() => {
        if(!loading){
            getData();
        }
    }, [])
    const getData = async (force = false) => {
        setLoading(true);
        let searchParams = new URLSearchParams();
        let res = await GetDataPromise(`${apiMain}/api/v2/setting/V2_tags?${searchParams.toString()}`, force);
        let parsed = JSON.parse(res);
        if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
          setDeta(parsed.data);
          setLoading(false);
          return;
        }
        setLoading(false);
    }
    const saveFunc = () => {
        // update datas
        setDialogData(false)
        setDialogOpen(false);
        getData(true)
    }
    
    const addFunc = () => {
        setDialogData({})
        setDialogOpen(true)
    }
    const closeFunc = () => {
        setDialogData(false)
        setDialogOpen(false)
    }
    if(loading){
        return (
            <LoadingColor/>
        )
    }
    let options = data.map((v) => {
        return {
            value: v.Tag_Id,
            name: (lan) ? v.Tag_EnName : v.Tag_Name
        }
    })
    return (
        <div style={{display: "flex", gap: "0.5rem"}}>
        <SelectInputWTitle
            style={style}
            name={name}
            title={title}
            error={error}
            options={options}
            first={first}
            value={value}
            onchange={onchange}
            selectableFirst={selectableFirst}
            placeHolder={placeHolder}
            required={required}
            ltr={ltr}
            lan={lan}
            disabled={disabled}
            search={search}
        />
        {
            (add) ? (
                <TextBtn2
                    newType={-1}
                    style={{maxWidth: "4rem", padding: "0rem"}}
                    onclick={addFunc}
                    text={
                        <IconAddBulk/>
                    }
                />
            ) : ""
        }
        <PopupMainPanel
            title={DictioneryPanel.packagesDict.tags[lang]}
            open={dialogOpen}
            close={closeFunc}
            lang={lang}
        >
            <FormTags apiBase={apiBase} dialogData={dialogData} save={saveFunc} lang={lang}/>
        </PopupMainPanel>
        </div>
    )

};